export type NavSocialIcon =
  | "instagram"
  | "twitter"
  | "facebook"
  | "linkedin"
  | "discord"
  | "email"

export type NavSectionLink = {
  label: string
  /** id of the homepage section this link scrolls to */
  sectionId: string
}

export type NavSocialLink = {
  label: string
  url: string
  icon: NavSocialIcon
}

export const navbarData: {
  links: NavSectionLink[]
  socials: NavSocialLink[]
} = {
  links: [
    { label: "About", sectionId: "about" },
    { label: "Sponsors", sectionId: "sponsors" },
    { label: "FAQ", sectionId: "faqs" },
  ],
  // Only entries with a non-empty `url` are rendered, so a platform we are not
  // on yet can sit here as a placeholder until there is a handle to point at.
  socials: [
    {
      label: "Instagram",
      url: "https://www.instagram.com/hack_dfw/",
      icon: "instagram",
    },
    {
      label: "X",
      url: "https://x.com/hackdfw",
      icon: "twitter",
    },
    {
      label: "LinkedIn",
      url: "https://www.linkedin.com/company/hackdfw",
      icon: "linkedin",
    },
    {
      label: "Email us",
      url: "mailto:info@hackdfw.com",
      icon: "email",
    },
    // The 2022 Discord invite in the repo is almost certainly expired. Drop a
    // fresh invite in here to light the icon up.
    { label: "Discord", url: "", icon: "discord" },
    { label: "Facebook", url: "", icon: "facebook" },
  ],
}
